// extracted by mini-css-extract-plugin
export default {"title":"container_title__P8QFL","container":"container_container__vnKrv"};